import { AfterContentChecked, Directive, ElementRef, TemplateRef, ViewContainerRef, inject } from '@angular/core';

@Directive({standalone: true, selector: '[cdkIfOnDom]'})
export class CdkIfOnDomDirective implements AfterContentChecked
{
    private _elementRef = inject(ElementRef);
    private _templateRef = inject<TemplateRef<any>>(TemplateRef);
    private _viewContainerRef = inject(ViewContainerRef);

    isCreated: boolean;



    /**
     * Constructor
     *
     * @param _elementRef
     * @param _templateRef
     * @param _viewContainerRef
     */
    constructor()
    {
        // Set the defaults
        this.isCreated = false;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * After content checked
     */
    ngAfterContentChecked(): void
    {
        if ( document.body.contains(this._elementRef.nativeElement) && !this.isCreated )
        {
            setTimeout(() => {
                this._viewContainerRef.createEmbeddedView(this._templateRef);
            }, 300);
            this.isCreated = true;
        }
        else if ( this.isCreated && !document.body.contains(this._elementRef.nativeElement) )
        {
            this._viewContainerRef.clear();
            this.isCreated = false;
        }
    }
}
